import * as React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

import { GetAccountNotificationsQuery } from '@graphql';

export interface ActionProps {
  type: 'standby' | 'booking' | 'event' | 'feedback' | 'request';
  subtype:
    | 'all'
    | 'friendship'
    | 'message'
    | 'mention'
    | 'new'
    | 'update'
    | 'late'
    | 'invitation'
    | 'upcoming';
  formik: FormikProps<any>;
  notifications: GetAccountNotificationsQuery['getAccountNotifications'];
}

function Action(props: Readonly<ActionProps>) {
  const { type, subtype, formik, notifications } = props;
  const { t } = useTranslation('notification');

  const handleSwitchChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const fieldName = event.target.name;
      // set the boolean value directly
      formik.setFieldValue(fieldName, checked);
    },
    [formik]
  );

  if (!formik.values[type]) {
    import.meta.env.DEV && console.error(`Type ${type} not found in formik values`);
    return null;
  }

  const isMailOverridable = (notifications as any)[type]?.[subtype]?.email?.isOverridable;
  const isPushOverridable = (notifications as any)[type]?.[subtype]?.push?.isOverridable;

  const isMailDisabled = !isMailOverridable || (type !== 'standby' && formik.values.standby.all.email);
  const isPushDisabled = !isPushOverridable || (type !== 'standby' && formik.values.standby.all.push);

  return (
    <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
      <Stack direction="row" width="70%" justifyContent="flex-start" alignItems="center">
        <Typography variant="caption" color="text.secondary">
          {t(`${type}.${subtype}`)}
        </Typography>
      </Stack>
      <Switch
        name={`${type}.${subtype}.email`}
        disabled={isMailDisabled}
        checked={formik.values[type][subtype].email}
        onChange={handleSwitchChange}
        color={'success'}
        sx={{
          opacity: isMailDisabled ? 0.5 : 1,
        }}
        slotProps={{
          input: {
            'aria-label': 'controlled',
          },
        }}
      />
      <Switch
        name={`${type}.${subtype}.push`}
        disabled={isPushDisabled}
        checked={formik.values[type][subtype].push}
        onChange={handleSwitchChange}
        color={'success'}
        sx={{
          opacity: isPushDisabled ? 0.5 : 1,
        }}
        slotProps={{
          input: {
            'aria-label': 'controlled',
          },
        }}
      />
    </Stack>
  );
}

export default Action;
